module.exports = __webpack_public_path__ + "img/venue-gray-2.a96c0735.png";